<template>
  <div class="pa4">
    <div v-if="proUserProjectCollaborations.length">

      <div class="flex flex-wrap w-100">

        <!-- MASONRY VERSION -->
        <div v-masonry
             transition-duration="0.2s"
             item-selector=".item"
             column-width="340"
             fit-width="true"
             gutter="20">
          <div v-masonry-tile class="grid-item item" v-for="project in proUserProjectCollaborations" :key="project.id">
            <!-- block item markup -->
            <pro-profile-card
                :project="project"
                :pro-user="project.creator">
            </pro-profile-card>
          </div>
        </div>
      </div>
    </div>

    <div v-if="!proUserProjectCollaborations.length">
      <div class="bg-near-white tc pa6 br2 fw5 silver ma4">
          <span class="f-headline">🐼</span><br>
          There are no collaborations for you to view.
      </div>
    </div>
  </div>
</template>

<script>

import proProfileService from '../../../../api/ProProfileService'
import proProfileCard from '../../profile/components/ProProfileCard'
import { mapState } from 'vuex'

export default {
    name: 'ProProfileCollaborations',

    components: {
        proProfileCard
    },

    props: {
        proUserId: {
            type: String,
            required: true,
        },
    },

    computed: {
        ...mapState(['currentUser', 'env']),
    },

    data() {
        return {
            proUserProjectCollaborations: [],
        };
    },

    methods: {

    },

    created() {
        proProfileService.getCollaborationsForUser(this.proUserId).then(response => {
            this.proUserProjectCollaborations = response.data;
        })
    }
}
</script>

<style scoped>



</style>



// WEBPACK FOOTER //
// src/main/frontend/vue/js/modules/pro/profile/components/ProProfileCollaborations.vue